import {
  carousel_slide_styles_default
} from "./chunk.H4P2BCLQ.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  watch
} from "./chunk.WGQU6RP3.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  i,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/carousel/carousel-slide.ts
var FadvCarouselSlide = class extends s {
  get backgroundUrl() {
    return this.background ? `url(${this.background})` : "";
  }
  firstUpdated() {
    this.setAttribute("tabindex", "1");
    this.handleBackgroundChange();
  }
  handleActiveChange() {
    if (this.active) {
      this.removeAttribute("aria-hidden");
      emit(this, "sl-after-show");
    } else {
      this.setAttribute("aria-hidden", "true");
      emit(this, "sl-after-hide");
    }
  }
  handleLabelChange() {
    this.setAttribute("aria-label", this.label);
  }
  handleBackgroundChange() {
    this.style.backgroundImage = this.backgroundUrl;
  }
  render() {
    return $`<div class=${o({
      "carousel-slide": true,
      "carousel-slide--active": this.active
    })} ><slot></slot></div>`;
  }
};
FadvCarouselSlide.styles = carousel_slide_styles_default;
__decorateClass([
  i(".carousel-slide")
], FadvCarouselSlide.prototype, "slide", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvCarouselSlide.prototype, "active", 2);
__decorateClass([
  e()
], FadvCarouselSlide.prototype, "label", 2);
__decorateClass([
  e()
], FadvCarouselSlide.prototype, "background", 2);
__decorateClass([
  watch("active", { waitUntilFirstUpdate: true })
], FadvCarouselSlide.prototype, "handleActiveChange", 1);
__decorateClass([
  watch("label", { waitUntilFirstUpdate: true })
], FadvCarouselSlide.prototype, "handleLabelChange", 1);
__decorateClass([
  watch("background", { waitUntilFirstUpdate: true })
], FadvCarouselSlide.prototype, "handleBackgroundChange", 1);
FadvCarouselSlide = __decorateClass([
  n("fadv-carousel-slide")
], FadvCarouselSlide);

export {
  FadvCarouselSlide
};
